// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
.provisioning__card {
  width: 100%;
  padding: 1.8em 4em 1em 4em;
  margin-top: 2em;
}
.provisioning__card .provisioning__title {
  font-family: "toyota-bold";
  margin-bottom: 1.5em;
  color: rgb(180, 57, 53);
  display: flex;
}
.provisioning__card .provisioning__title-warning {
  font-family: "toyota-bold";
  color: rgb(180, 57, 53);
}
.provisioning__card .provisioning__table {
  width: 100%;
}
.provisioning__card .provisioning__table th {
  text-align: left;
  color: rgb(180, 57, 53);
}
.provisioning__card .provisioning__retrigger-button {
  color: rgb(180, 57, 53);
  padding: 0;
  line-height: 1em;
}
.provisioning__card .provisioning__retrigger-button-disabled {
  color: rgb(176, 173, 171) !important;
}
.provisioning__card .provisioning__retriger-button-title {
  color: rgb(255, 255, 255);
  background-color: rgb(180, 57, 53);
}
.provisioning__card .child-row td:first-child {
  padding-left: 1em;
}

.status__refresh button {
  background: transparent;
  border: none;
  line-height: 0;
}
.status__refresh button:hover {
  cursor: pointer;
}
.status__refresh button img {
  height: 1.5em;
}

.refresh__icon {
  font-size: 34px;
  width: 34px;
  height: 34px;
  margin-bottom: -8px;
}

.provision__history {
  flex-direction: row;
  justify-content: flex-end;
}
.provision__history button {
  border: none;
  color: rgb(180, 57, 53);
  font-family: "toyota-bold";
  background-color: rgb(255, 255, 255);
}
.provision__history button:hover {
  cursor: pointer;
}

.provisioning-footer {
  margin-top: 1em;
  padding: 1em 0;
  display: flex;
  flex-direction: row;
}
.provisioning-footer .activate-dcm {
  background-color: rgb(180, 57, 53);
  border: 0.05em solid rgb(180, 57, 53);
  border-radius: 0.25em;
  font-family: "toyota-book";
  color: rgb(255, 255, 255);
  margin-right: 1em;
}
.provisioning-footer .show-flags {
  background-color: rgb(180, 57, 53);
  border: 0.05em solid rgb(180, 57, 53);
  border-radius: 0.25em;
  font-family: "toyota-book";
  color: rgb(255, 255, 255);
}
.provisioning-footer .provisioning-footer-buttons {
  padding-right: 1.5em;
}
.provisioning-footer .disabled {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/fonts/toyota-fonts.scss","webpack://./src/app/admin/provisioning/provisioning.component.scss","webpack://./src/app/styles/colors/palette.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,yDAAA;ACCF;ADCA;EACE,0BAAA;EACA,yDAAA;ACCF;ADCA;EACE,6BAAA;EACA,4DAAA;ACCF;AARA;EACE,WAAA;EAEA,0BAAA;EACA,eAAA;AASF;AAPE;EACE,0BDSG;ECRH,oBAAA;EACA,uBCuBS;EDtBT,aAAA;AASJ;AAPI;EACE,0BDGC;ECFD,uBCkBO;ADTb;AALE;EACE,WAAA;AAOJ;AALI;EACE,gBAAA;EACA,uBCSO;ADFb;AAHE;EACE,uBCIS;EDHT,UAAA;EACA,gBAAA;AAKJ;AAFE;EACE,oCAAA;AAIJ;AADE;EACE,yBCxCI;EDyCJ,kCCPS;ADUb;AAAE;EACE,iBAAA;AAEJ;;AAGE;EACE,uBAAA;EACA,YAAA;EACA,cAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAGI;EACE,aAAA;AADN;;AAOA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,yBAAA;AAJF;AAME;EACE,YAAA;EACA,uBC7CS;ED8CT,0BD9DG;EC+DH,oCCjFI;AD6ER;AAMI;EACE,eAAA;AAJN;;AASA;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AANF;AAQE;EACE,kCC9DS;ED+DT,qCAAA;EACA,qBAAA;EACA,0BDvFG;ECwFH,yBCpGI;EDqGJ,iBAAA;AANJ;AASE;EACE,kCCvES;EDwET,qCAAA;EACA,qBAAA;EACA,0BDhGG;ECiGH,yBC7GI;ADsGR;AAUE;EACE,oBAAA;AARJ;AAWE;EACE,YAAA;AATJ","sourcesContent":["@font-face {\n  font-family: 'toyota-bold';\n  src: url('/fonts/ToyotaType-Bold.ttf') format('truetype')\n}\n@font-face {\n  font-family: 'toyota-book';\n  src: url('/fonts/ToyotaType-Book.ttf') format('truetype')\n}\n@font-face {\n  font-family: 'toyota-regular';\n  src: url('/fonts/ToyotaType-Regular.ttf') format('truetype')\n}\n// Book families\n$book: 'toyota-book';\n\n// Regular families\n$regular: 'toyota-regular';\n\n// Bold families\n$bold: 'toyota-bold';\n","@import \"../../../app/styles/fonts/toyota-fonts.scss\";\n@import \"../../../app/styles/colors/font_color_variables.scss\";\n\n.provisioning__card {\n  width: 100%;\n\n  padding: 1.8em 4em 1em 4em;\n  margin-top: 2em;\n\n  .provisioning__title {\n    font-family: $bold;\n    margin-bottom: 1.5em;\n    color: $toyota_red;\n    display: flex;\n\n    &-warning {\n      font-family: $bold;\n      color: $toyota_red;\n    }\n  }\n\n  .provisioning__table {\n    width: 100%;\n\n    th {\n      text-align: left;\n      color: $toyota_red;\n    }\n  }\n\n  .provisioning__retrigger-button {\n    color: $retrigger-button;\n    padding: 0;\n    line-height: 1em;\n  }\n\n  .provisioning__retrigger-button-disabled {\n    color: $prov-disabled-text  !important;\n  }\n\n  .provisioning__retriger-button-title {\n    color: $white;\n    background-color: $toyota-red;\n  }\n\n  .child-row td:first-child {\n    padding-left: 1em;\n  }\n}\n\n.status__refresh {\n  button {\n    background: transparent;\n    border: none;\n    line-height: 0;\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    img {\n      height: 1.5em;\n    }\n  }\n}\n\n\n.refresh__icon {\n  font-size: 34px;\n  width: 34px;\n  height: 34px;\n  margin-bottom: -8px;\n}\n\n.provision__history {\n  flex-direction: row;\n  justify-content: flex-end;\n\n  button {\n    border: none;\n    color: $toyota_red;\n    font-family: $bold;\n    background-color: $white;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n\n.provisioning-footer {\n  margin-top: 1em;\n  padding: 1em 0;\n  display: flex;\n  flex-direction: row;\n\n  .activate-dcm {\n    background-color: $toyota_red;\n    border: 0.05em solid $toyota_red;\n    border-radius: 0.25em;\n    font-family: $book;\n    color: $white;\n    margin-right: 1em;\n  }\n\n  .show-flags {\n    background-color: $toyota_red;\n    border: 0.05em solid $toyota_red;\n    border-radius: 0.25em;\n    font-family: $book;\n    color: $white;\n  }\n\n  .provisioning-footer-buttons {\n    padding-right: 1.5em;\n  }\n\n  .disabled {\n    opacity: 0.5;\n  }\n}","//white\n$white: rgb(255, 255, 255);\n$dull_white: rgb(250, 250, 250);\n$white_2:rgb(242, 242, 242);\n\n// Grey Colors\n$grey: rgb(118, 118, 118);\n$dark_grey:rgb(33, 33, 33);\n$charcoal_gray: rgb(49, 56, 58);\n$content_grey: rgb(41, 45, 48);\n$dark_grey_2: rgb(34, 34, 34);\n$light_grey1: rgba(248, 248, 248, 0.8);\n$light_grey: rgba(0, 0, 0, 0.1);\n$light_grey2: rgba(0, 0, 0, 0.2);\n$light_grey3: rgb(176, 173, 171);\n$light_grey4: rgb(238, 238, 238);\n$charcoal_gray_transparency: rgba(49, 56, 58, 0.1);\n$black_grey:rgb(33, 13, 13);\n$text_grey:rgb(138, 138, 138);\n$warm_grey:rgb(155, 155, 155);\n$light_grey5: rgb(222, 222, 222);\n$light_grey6: rgb(181, 181, 181);\n$light_grey7: rgb(197, 192, 192);\n$light_grey8:rgb(226, 222, 222);\n$light_grey9:rgb(205, 189, 189);\n$light_grey11:rgb(216, 216, 216);\n$light_grey12:rgb(240, 240, 240);\n$light_grey13:rgb(182,182,182);\n$bg_grey:rgb(245, 245, 246);\n$light_shade_grey:rgb(170,170,170);\n$light_grey_3: rgb(207,207,207);\n$light_grey10: rgb(165, 165, 165);\n$light_grey12: rgb(242, 242, 242);\n$light_grey13: rgb(217, 217, 217);\n// Red Colors\n$toyota_red: rgb(180, 57, 53);\n$red: rgb(255, 5, 0);\n$toyota_red_light: rgba(180, 57, 53, 0.4);\n$red_transparency: rgba(255, 0, 0, 0.1);\n$red_transparency2: rgba(255, 0, 0, 0.2);\n$dark_red:rgb(217, 37, 42);\n$customer_invalid_red: rgb(255, 5, 0);\n$session_timeout_red: rgb(235, 10, 30);\n$status_red: rgb(204, 0, 0);\n$banner_red:rgb(200,0,0);\n// orange\n$orange: rgb(249, 130, 5);\n// black\n$black: rgb(0, 0, 0);\n$black_grey:rgb(74, 74, 74); \t\n$black_grey2:rgb(41, 45, 48);\n// Green\n$dark_green:rgb(48, 120, 58);\n$green: rgb(26, 151, 105);\n$medium_green:rgb(57, 181, 74);\n$green_transparency2: rgba(26, 151, 105, 0.3);\n$light_green: rgba(39, 170, 122, 0.2);\n// Yellow\n$non-telematics-yellow: rgba(255, 212, 0, 1);\n$yellow: rgb(255,255,0);\n//pink\n$pink:rgb(253, 230, 232);\n// Opacities and compositions\n$black-transparency: rgba($black, 0.87);\n$grey_transparency: rgba(0, 0, 0, 0.5);\n$transparent: rgba(0, 0, 0, 0);\n$edit_icon_color: rgb(11, 100, 255);\n$cornflower_blue: rgb(100, 149, 237);\n$blue: rgba(0, 126, 255, 1);\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
